import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
var PartnersSection = function PartnersSection() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort,
    tLong = _useTranslation.tLong;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "bg-[#F4F9FE] px-4 pt-[70px] pb-8 md:pt-[104px] md:pb-[64px] md:px-0  lg:flex lg:flex-col lg:gap-10"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 md:max-w-[1152px] md:mx-auto md:px-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-primary text-center text-2xl font-bold md:max-w-[765px] md:text-[40px] md:leading-[56px] mx-auto"
  }, tShort("about_us/partners_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-center text-[#576678] text-base font-regular leading-6 md:text-2xl md:leading-10 md:max-w-[765px] mx-auto"
  }, tLong("about_us/partners_subtitle", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap items-center justify-between w-full px-4 md:max-w-[1152px] md:mx-auto md:px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-[155px] h-[155px] lg:w-[267px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/elm.svg",
    alt: tLong("about_us/partner_item_alt_1", {
      ns: "web_common"
    }),
    className: "w-full h-full lg:object-cover",
    loading: "lazy",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-[155px] h-[155px] lg:w-[267px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/impact.svg",
    alt: tLong("about_us/partner_item_alt_2", {
      ns: "web_common"
    }),
    className: "w-full h-full lg:object-cover",
    loading: "lazy",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-[155px] h-[155px] lg:w-[267px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/tawuniya.svg",
    alt: tLong("about_us/partner_item_alt_3", {
      ns: "web_common"
    }),
    className: "w-full h-full lg:object-cover",
    loading: "lazy",
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-[155px] h-[155px] lg:w-[267px]"
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/about-us/erayah.svg",
    alt: tLong("about_us/partner_item_alt_4", {
      ns: "web_common"
    }),
    className: "w-full h-full lg:object-cover",
    loading: "lazy",
    width: "100%",
    height: "100%"
  })))));
};
export default PartnersSection;